module.exports = __webpack_public_path__ + "img/hilton.ac7b06f5.png";